import React from "react";
import { motion } from "framer-motion";
import { styles } from "../styles";
import { landingData } from "../data";

const Clients = ({ animations }) => {
  return (
    <motion.section
      initial="initial"
      whileInView="animate"
      viewport={{ once: true, amount: 0.2 }}
      variants={animations.staggerChildren}
      className="py-12 md:py-16 bg-white"
    >
      <div className={styles.container}>
        <motion.h2
          variants={animations.fadeInUp}
          className={`${styles.sectionTitle} text-primary text-center mb-8 md:mb-12`}
        >
          Our Client
        </motion.h2>

        {/* Desktop Version */}
        <div className="hidden md:grid grid-cols-3 md:grid-cols-4 gap-8">
          {landingData.clients.map((client, index) => (
            <motion.div
              key={index}
              variants={animations.scaleIn}
              whileHover={{ scale: 1.05 }}
              className="flex items-center justify-center my-6 md:my-12"
            >
              <img
                src={client.logo}
                alt={client.name}
                className="w-full max-w-[200px] transition-all duration-300 hover:brightness-110"
                loading="lazy"
              />
            </motion.div>
          ))}
        </div>

        {/* Mobile Version */}
        <motion.div
          className="md:hidden relative"
          variants={animations.fadeInUp}
        >
          <div className="overflow-x-auto scrollbar-hide pb-4">
            <div className="flex space-x-6">
              {landingData.clients.map((client, index) => (
                <div
                  key={index}
                  className="flex-none w-32 flex items-center justify-center"
                >
                  <img
                    src={client.logo}
                    alt={client.name}
                    className="w-full max-w-[120px]"
                    loading="lazy"
                  />
                </div>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </motion.section>
  );
};

export default Clients;
